import { memo, FC } from 'react';
import { Box, ListItem, UnorderedList, Text } from '@chakra-ui/react';

import { CustomerForForms } from 'types/customer';
import { CustomerListHeader } from './CustomerListHeader';
import { CustomerListItem } from './CustomerListItem';
import { CustomerListSkeleton } from './CustomerListSkeleton';
import { CustomerListSearchFields } from './CustomerListSearchFields';

type Props = {
  loading: boolean;
  id: string;
  name: string;
  detail: string;
  total: number;
  selectedCustomersLength: number;
  filteredCustomers: CustomerForForms[];
  isSelectedAll: boolean;
  isIndeterminate: boolean;
  handleIdChange: (id: string) => void;
  handleNameChange: (name: string) => void;
  handleDetailChange: (detail: string) => void;
  handleCheckboxChange: (customer: CustomerForForms) => void;
  handleCustomerClick: (customer: CustomerForForms) => void;
  handleParentCheckboxClick: () => void;
};

export const CustomerListView: FC<Props> = memo(
  ({
    loading,
    id,
    name,
    detail,
    total,
    selectedCustomersLength,
    filteredCustomers,
    isSelectedAll,
    isIndeterminate,
    handleIdChange,
    handleNameChange,
    handleDetailChange,
    handleCheckboxChange,
    handleCustomerClick,
    handleParentCheckboxClick,
  }) => {
    if (loading) {
      return <CustomerListSkeleton />;
    }

    return (
      <>
        {/* 検索フィルタ */}
        <CustomerListSearchFields
          id={id}
          name={name}
          detail={detail}
          handleIdChange={handleIdChange}
          handleNameChange={handleNameChange}
          handleDetailChange={handleDetailChange}
        />
        <Box m="20px 0 0 0px" w="95%">
          {/* 顧客一覧のヘッダ */}
          <CustomerListHeader
            isSelectedAll={isSelectedAll}
            isIndeterminate={isIndeterminate}
            handleParentCheckboxClick={handleParentCheckboxClick}
          />
          {/* 顧客一覧 */}
          <UnorderedList h="400px" overflowY="auto">
            {filteredCustomers.map((item) => (
              <ListItem key={item.id} listStyleType="none">
                <CustomerListItem
                  item={item}
                  isSelected={item.isSelected}
                  handleCheckboxChange={() => handleCheckboxChange(item)}
                  handleCustomerClick={() => handleCustomerClick(item)}
                />
              </ListItem>
            ))}
          </UnorderedList>
          {/* 顧客一覧のフッタ */}
          <Text color="gray.500" textAlign="end" mt="10px" mr="20px">
            {total} 件中 {selectedCustomersLength} 件が選択されています
          </Text>
        </Box>
      </>
    );
  },
);
